module.exports = {"Warn":"Warning","Error":"Error","Critical":"Critical","Ok":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle/message-en.json
// module id = pOMu
// module chunks = 20